import React from 'react';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../locales/localesConfig';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import FormatTooling from '../../../tooling/formatTooling';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import Constants from '../../../definitions/constants';
import TableDescriptors from '../../../definitions/tableDescriptors';

import GlassPopup from '../common/interface/glassPopup';
import ObjectDefinitionEditor from '../common/inputs/objectDefinitionEditor';
import ErrorFeedback from '../common/feedback/errorFeedback';
import FieldInfo from '../common/inputs/fieldInfo';
import Header from '../../components/periodAdmin/header';
import BlueHeader from '../common/inputs/blueHeader';
import EntityTable from '../common/entity/entityTable';
import CalculationUnitsFilter from '../../components/reportFileAdmin/calculationUnitsFilter';
import LocaleTooling from '../../../tooling/localeTooling';

const EmailDetailPopup = props => {
  const {
    handleShowPopup,
    statusButton,
    loadingButton,
    fullLoading,
    popupState,
    handleButton,
    emailHistoryPage,
    emailHistoryTotalPages,
    emailHistoryTotalRecords,
    emailHistoryFetchListChangePage,
    emailHistoryData,
    emailHistoryLoading,
    emailHistoryHandleNotificationDetail,
    periodData,
    handleSearchButton,
    calcFilterOnChangeFilter,
    calcFilterFilterValues,
    calcFilterGroupsData,
    calcFilterGroupsLoading,
    calcFilterCalculationUnitsData,
    calcFilterCalculationUnitsLoading,
    calcFilterCalculationUnitsFetchAction,
    handleRefreshEmailHistory,
  } = props;

  let emailHistoryActions = [emailHistoryHandleNotificationDetail];
  let emailHistoryIcons = ["info-circle"]
  let emailHistoryTooltip = [intl.formatMessage({ id: "reportFileAdmin.tableActions.info"})]
  let emailHistoryTooltipForceShow = [true]

  return (
    <GlassPopup
      className="form_popup email_popup notifications_popup"
      title={LocaleTooling.getCalculationUnitContextLocale(<FormattedMessage id="reportFileAdmin.email.popupTitle"/>)}
      type={Constants.interface.popup.types.LATERAL}
      handleButton={handleButton}
      handleExtraButton={handleSearchButton}
      extraButtonIcon="search"
      buttonText={LocaleTooling.getCalculationUnitContextLocale(<FormattedMessage id="reportFileAdmin.email.sendEmailButton"/>)}
      {...props}
    >
      <div>
        <CalculationUnitsFilter
          onChangeFilter={calcFilterOnChangeFilter}
          filterValues={calcFilterFilterValues}
          groupsData={calcFilterGroupsData}
          groupsLoading={calcFilterGroupsLoading}
          calculationUnitsData={calcFilterCalculationUnitsData}
          calculationUnitsLoading={calcFilterCalculationUnitsLoading}
          calculationUnitsFetchAction={calcFilterCalculationUnitsFetchAction}
          hideReportValueFilters={true}
          hideTitle={true}
        />
        <div className="email_history_header_wrapper">
          <BlueHeader
            labelLocale={<FormattedMessage id="reportFileAdmin.email.sendEmailHistoryTitle"/>}
          />
          {handleRefreshEmailHistory && (
            <i 
              className={"fas fa-sync email_history_header_refresh_button"}
              onClick={handleRefreshEmailHistory}
            />
          )}
        </div>
        <EntityTable 
          entityTableDescriptor={TableDescriptors.emailDetailList}
          data={emailHistoryData}
          loading={emailHistoryLoading}
          page={emailHistoryPage}
          totalPages={emailHistoryTotalPages}
          totalRecords={emailHistoryTotalRecords}
          fetchListChangePage={emailHistoryFetchListChangePage}
          disableDisbledEntitiesControl={true}
          handleCustomActions={emailHistoryActions}
          customActionsIcons={emailHistoryIcons}
          customActionsTooltips={emailHistoryTooltip}
          customActionsForceShow={emailHistoryTooltipForceShow}
        />
      </div>
    </GlassPopup>
  );
};

export default EmailDetailPopup;



// WEBPACK FOOTER //
// ./source/client/components/reportFileAdmin/emailDetailPopup.jsx